
import * as React from 'react';
import { BookemZulu } from 'src/core/services/data/JayDataContext';
import { ToolbarVisibility, DataTableView } from 'src/core/ui/data-table.view';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { StatusTexts } from "src/app/shared/status-texts";

type QuoteItemW = BookemZulu.Bookings.Logic.ViewModels.QuoteItem;

interface IGroupEntriesViewProps {
	dataService: DataSet<QuoteItemW>;
	reload: () => void;
	setBusy: (isBusy: boolean) => void;
}

interface IGroupEntriesViewState {

}

export default class GroupEntriesView extends React.Component<IGroupEntriesViewProps, IGroupEntriesViewState>{

	public statusText(status: number): string {
		return StatusTexts.getQuoteStatusFromNumber(status);
	}

	render() {

		let visibility = ToolbarVisibility.hideModifyButtons | ToolbarVisibility.hideSearch;

		const columns = [
			{
				key: 'quoteNumber',
				dataIndex: 'quoteNumber',
				title: 'Quote Number',
				render: (text, record: QuoteItemW) => <Link to={`/bookings/quotes/${record.id}`}>{text}</Link>,
			},
			{
				key: 'clientDisplayName',
				dataIndex: 'clientDisplayName',
				title: 'Client',
				render: (text, record: QuoteItemW) => <Link to={`/crm/clients/${record.clientId}`}>{text}</Link>,
			},
			{
				key: 'status',
				dataIndex: 'status',
				title: 'Status',
				render: (text: string, record: QuoteItemW) => {
					let status;
					let icon;
					let style: any = {
					};
					switch (record.status) {
						case 1:
							status = 'primary';
							style.backgroundColor = '#ffffcd';
							style.borderColor = 'black';
							style.color = 'black';
							break;
						case 2:
							status = 'primary';
							style.backgroundColor = '#28a745';
							style.borderColor = '#28a745';
							break;
						case 3:
							status = 'primary';
							icon = "check";
							break;
						case 4:
							status = 'danger';
							break;
					}
					return <Button type={status} style={style} icon={icon} size="small">{this.statusText(record.status)}</Button>
				}
			},
			{
				key: 'totalSaleGross',
				title: 'Sell price',
				dataIndex: 'totalSaleGross',
				render: (text, record: QuoteItemW) => {
					return `${text} (${record.marketCurrency})`;
				}
			},
			{
				key: 'paxCount',
				dataIndex: 'paxCount',
				title: 'Pax count'
			},

			{
				key: 'managedByUserName',
				dataIndex: 'managedByUserName',
				title: 'Managed By'
			}
		]

		return (
			<React.Fragment>
				<DataTableView
					mode={'display'}
					setBusy={this.props.setBusy}
					columns={columns}
					model={this.props.dataService}
					hideToolbar={visibility}
					selection={false}
				/>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/quote-groups/form/parts/entries.view.tsx